import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IBoton, ICliente, TipoBoton } from 'modelos/src';

/**
 * Tab "Sirenas": config de sirenas (cobertura, firmware, restricciones,
 * compartir), controles RF y pórticos.
 * Recibe el formulario raíz por referencia: edita los mismos controles.
 */
@Component({
  selector: 'app-tab-sirenas',
  templateUrl: './tab-sirenas.component.html',
  styleUrls: ['./tab-sirenas.component.scss'],
  standalone: false,
})
export class TabSirenasComponent implements OnInit {
  @Input() public formulario?: UntypedFormGroup;
  @Input() public clientes: ICliente[] = [];
  @Input() public botones: IBoton[] = [];
  /** Los controles RF asocian botones del cliente: ocultos en el wizard de creación. */
  @Input() public mostrarControlesRf = true;

  public acciones: TipoBoton[] = ['Reflector', 'Sirena', 'Alerta'];
  public boton1?: string;
  public boton2?: string;
  public boton3?: string;

  get configuracion(): UntypedFormGroup {
    return this.formulario?.get('configuracion') as UntypedFormGroup;
  }

  get sirenas(): boolean {
    return this.formulario?.get('sirenas')?.value;
  }

  get actualizaciones(): boolean {
    return this.configuracion.get('actualizacionesFirmware')?.value;
  }

  get restriccion(): boolean {
    return this.configuracion.get('restringirUsoSirenas')?.value;
  }

  public updateBoton(number: number, value: string): void {
    if (value === 'Sirena' || value === 'Reflector') {
      if (number === 1) {
        this.boton1 = value;
        this.configuracion.patchValue({ boton1: value });
      }
      if (number === 2) {
        this.boton2 = value;
        this.configuracion.patchValue({ boton2: value });
      }
      if (number === 3) {
        this.boton3 = value;
        this.configuracion.patchValue({ boton3: value });
      }
    } else {
      if (number === 1) {
        this.boton1 = value;
        this.configuracion.patchValue({ boton1: '' });
      }
      if (number === 2) {
        this.boton2 = value;
        this.configuracion.patchValue({ boton2: '' });
      }
      if (number === 3) {
        this.boton3 = value;
        this.configuracion.patchValue({ boton3: '' });
      }
    }
  }

  // Deriva el estado de los selects de acción a partir de los valores guardados
  // ('Reflector'/'Sirena' literales, mongoId → 'Alerta', vacío → sin acción).
  private cargarConfigControles(): void {
    const bot1 = this.configuracion?.get('boton1')?.value;
    if (bot1 === 'Reflector' || bot1 === 'Sirena') {
      this.boton1 = bot1;
    } else if (bot1 === null || bot1 === undefined) {
      this.boton1 = undefined;
    } else {
      this.boton1 = 'Alerta';
    }

    const bot2 = this.configuracion?.get('boton2')?.value;
    if (bot2 === 'Reflector' || bot2 === 'Sirena') {
      this.boton2 = bot2;
    } else if (bot2 === null || bot2 === undefined) {
      this.boton2 = undefined;
    } else {
      this.boton2 = 'Alerta';
    }

    const bot3 = this.configuracion?.get('boton3')?.value;
    if (bot3 === 'Reflector' || bot3 === 'Sirena') {
      this.boton3 = bot3;
    } else if (bot3 === null || bot3 === undefined) {
      this.boton3 = undefined;
    } else {
      this.boton3 = 'Alerta';
    }
  }

  ngOnInit(): void {
    this.cargarConfigControles();
  }
}
